import { useState } from 'react';
import { Route, Switch, useLocation } from 'wouter';
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "@/components/ThemeProvider";
import { AuthProvider } from "@/hooks/useAuth";
import { Sidebar } from "@/components/Sidebar";
import { Header } from "@/components/Header";
import { Dashboard } from "@/pages/Dashboard";
import { MCQPractice } from "@/pages/MCQPractice";
import { ExamSection } from "@/pages/exam/ExamSection";
import { PracticeHistory } from "@/pages/PracticeHistory";
import { SubjectSections } from "@/pages/SubjectSections";
import { AuthCallback } from "@/pages/AuthCallback";
import ArticleGrid from './pages/constitution/ArticleGrid';
import NewsGrid from './pages/news/NewsGrid';
import EnglishGrid from './pages/english/EnglishGrid';
import { MathsPractice } from './pages/maths/MathsPractice';
import { ReasoningPractice } from './pages/reasoning/ReasoningPractice';
import { PublicApp } from './components/PublicApp';
import { MainApp } from './components/MainApp';
import { useAuth } from "@/hooks/useAuth";
import { Register } from './pages/Register';
import { Login } from './pages/Login';
import { HelmetProvider } from 'react-helmet-async';

// function PublicApp() {
//   const [activeSection, setActiveSection] = useState('mcq');
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   const handleSectionChange = (section: string) => {
//     setActiveSection(section);
//     setSidebarOpen(false);
//   };

//   const handleSidebarToggle = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   const renderContent = () => {
//     switch (activeSection) {
//       case 'mcq':
//         return <MCQPractice />;
//       case 'general-knowledge':
//       case 'english':
//         return <EnglishGrid />
//       case 'mathematics':
//         return <MathsPractice />
//       case 'reasoning':
//         return <ReasoningPractice />
//         // return <SubjectSections activeSection={activeSection} />;
//       default:
//         return <MCQPractice />;
//     }
//   };

//   return (
//     <div className="flex min-h-screen gcep-gradient-bg">
//       <Sidebar
//         isOpen={sidebarOpen}
//         onClose={() => setSidebarOpen(false)}
//         activeSection={activeSection}
//         onSectionChange={handleSectionChange}
//       />
      
//       <main className="flex-1 lg:ml-72 transition-all duration-300">
//         <Header onSidebarToggle={handleSidebarToggle} />
//         {renderContent()}
//       </main>
//     </div>
//   );
// }
// function MainApp() {

//   console.warn("MainApp Called");
//   const [activeSection, setActiveSection] = useState('dashboard');
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   const handleSectionChange = (section: string) => {
//     setActiveSection(section);
//     setSidebarOpen(false);
//   };

//   const handleSidebarToggle = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   const renderContent = () => {
//     switch (activeSection) {
//       case 'dashboard':
//         return <Dashboard onSectionChange={handleSectionChange} />;
//       case 'mcq':
//         return <MCQPractice />;
//       case 'exam':
//         return <ExamSection onSectionChange={handleSectionChange} />;
//       case 'history':
//         return <PracticeHistory />;
//       case 'constitution':
//         return <ArticleGrid />
//       case 'current-affairs':
//         return <NewsGrid />
//       case 'general-knowledge':
//       case 'english':
//         return <EnglishGrid />
//       case 'mathematics':
//         return <MathsPractice />
//       case 'reasoning':
//         return <ReasoningPractice />
//         // return <SubjectSections activeSection={activeSection} />;
//       default:
//         return <Dashboard onSectionChange={handleSectionChange} />;
//     }
//   };

//   return (
//     <div className="flex min-h-screen gcep-gradient-bg">
//       <Sidebar
//         isOpen={sidebarOpen}
//         onClose={() => setSidebarOpen(false)}
//         activeSection={activeSection}
//         onSectionChange={handleSectionChange}
//       />
      
//       <main className="flex-1 lg:ml-72 transition-all duration-300">
//         <Header onSidebarToggle={handleSidebarToggle} />
//         {renderContent()}
//       </main>
//     </div>
//   );
// }


function App() {
  return (
    <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <TooltipProvider>
            <Toaster />
              <AppRoutes />
          </TooltipProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
    </HelmetProvider>
  );
}

// Separate component where useAuth is valid
function AppRoutes() {
  const { user } = useAuth();

  return (
    <Switch>
      {/* OAuth callback route */}
      <Route path="/auth/callback">
        <AuthCallback />
      </Route>

      {/* Public routes */}
      <Route path="/public">
        <PublicApp />
      </Route>
      <Route path="/login">
        <Login />
      </Route>
      <Route path="/register">
        <Register />
      </Route>

      {/* Default route */}
      <Route path="/">
        {user ? <MainApp /> : <PublicApp />}
      </Route>
    </Switch>
  );
}


export default App;